// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promotion-card[data-v-70c26b49] {\n  background: var(--magic-tertiary, #311261);\n}\n\n.title[data-v-70c26b49] {\n  color: var(--magic-light, #fff);\n}\n\n.text[data-v-70c26b49] {\n  font-size: 1rem;\n  color: var(--magic-light, #fff);\n}\n\n.link[data-v-70c26b49] {\n  --magic-text-primary: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
